// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"527":"00fe0b7e","910":"7c925ae8"}[chunkId] + ".chunk.js";
};